module.exports = __webpack_public_path__ + "static/clayborn-2.71abd44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/clayborn-2.jpg
// module id = 494
// module chunks = 228922781756548